import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import RoleSidebar from "../shared/RoleSidebar";
import NotificationToolbarBell from "../shared/NotificationToolbarBell";
import AppBottomDock from "../shared/AppBottomDock";
import { initialSidebarExpanded } from "../../utils/layoutSidebar";
import "../customer/customerLayot.css";
import api from "../../services/api";
import { buildAuthOverlayUrl } from "../../utils/authNavigation";

function CareManagerLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(initialSidebarExpanded);
  const navigate = useNavigate();
  const location = useLocation();

  function isDesktopViewport() {
    if (typeof window === "undefined") return false;
    return window.matchMedia("(min-width: 901px)").matches;
  }

  function handleMenuToggle() {
    if (isDesktopViewport()) {
      setSidebarExpanded((s) => !s);
      return;
    }
    setSidebarOpen((s) => !s);
  }

  useEffect(() => {
    const token = api.getToken?.();
    const authRole = api.getAuthRoleFromToken?.();
    if (!token) {
      navigate(
        buildAuthOverlayUrl("/", {
          returnTo: location.pathname || "/care-manager",
          tab: "care-manager",
        }),
        { replace: true }
      );
      return;
    }
    if (authRole && authRole !== "CARE_MANAGER") {
      navigate("/", { replace: true });
    }
  }, [navigate, location.pathname]);

  return (
    <div className={`customer-layout ${sidebarExpanded ? "customer-layout--expanded" : "customer-layout--compact"}`}>
      <button
        type="button"
        className="layout-hamburger"
        aria-label="Open menu"
        onClick={handleMenuToggle}
      >
        ☰
      </button>
      {sidebarOpen ? (
        <button
          type="button"
          className="layout-overlay"
          aria-label="Close menu overlay"
          onClick={() => setSidebarOpen(false)}
        />
      ) : null}
      <RoleSidebar
        role="careManager"
        isOpen={sidebarOpen}
        isExpanded={sidebarExpanded}
        onClose={() => setSidebarOpen(false)}
        onToggleExpand={handleMenuToggle}
      />
      <div className="customer-layout__main">
        <div className="customer-layout__toolbar">
          <button
            type="button"
            className="layout-hamburger layout-hamburger--toolbar"
            aria-label="Open menu"
            onClick={handleMenuToggle}
          >
            ☰
          </button>
          <div className="customer-layout__toolbar-actions">
            <NotificationToolbarBell />
          </div>
        </div>
        <div className="customer-layout__content">
          <Outlet />
        </div>
      </div>
      <AppBottomDock />
    </div>
  );
}

export default CareManagerLayout;
